import { writable } from "svelte/store";

// Separate token for agent testing (uses /login instead of /admin/login)
let stored_agent_token = localStorage.getItem("agent_token");
if (!stored_agent_token) {
    localStorage.setItem("agent_token", "");
    stored_agent_token = "";
}
export const agentToken = writable(stored_agent_token);
agentToken.subscribe(value => {
    localStorage.setItem("agent_token", value || '');
});

// Selected workspace ID for control-workspace header
let stored_workspace = localStorage.getItem("agent_workspace");
if (!stored_workspace) {
    localStorage.setItem("agent_workspace", "");
    stored_workspace = "";
}
export const agentWorkspace = writable(stored_workspace);
agentWorkspace.subscribe(value => {
    localStorage.setItem("agent_workspace", value || '');
});
